import { ensureSubsystem } from '../../../utils/meetingType'
import { CUSTOMER_FORM, SIMPLY_BOOK_ME } from './reducer/Wizard'
import settings from '../../components/settings'

const findServiceData = (services, selectedService) => {
  if (!services || !services.length < 0) return null

  if (!selectedService) return null

  const serviceData = services.find(
    (f) =>
      f.id === parseInt(selectedService.serviceId, 10) &&
      f.serviceType === selectedService.serviceType &&
      f.code === (selectedService.code || selectedService.id) // yes, this is terrible code
  )
  return serviceData
}

const getMeetingTypeContent = ({
  meetingTypes,
  currentMeetingTypeName,
  bookingSystem,
  storeSubSystem,
  serviceId,
}) => {
  if (!currentMeetingTypeName) return null

  let meetingTypeName = currentMeetingTypeName
    .replace('slot', '')
    .toLowerCase()
    .trim()

  if (bookingSystem === SIMPLY_BOOK_ME && meetingTypeName === SIMPLY_BOOK_ME) {
    meetingTypeName = 'store'
  }

  let currentMeetingType = CUSTOMER_FORM
  switch (bookingSystem) {
    case SIMPLY_BOOK_ME:
      currentMeetingType = SIMPLY_BOOK_ME
      break
    default:
      currentMeetingType = CUSTOMER_FORM
      break
  }

  const filteredMeetingTypesBySubsystem = meetingTypes?.filter((m) =>
    ensureSubsystem(m, storeSubSystem, settings.serviceMappings)
  )

  const meetingType =
    filteredMeetingTypesBySubsystem &&
    filteredMeetingTypesBySubsystem.find(
      (f) =>
        f.code.trim() === meetingTypeName &&
        f.type === currentMeetingType &&
        (currentMeetingType === CUSTOMER_FORM || f.id === serviceId)
    )

  return meetingType
}

const getMeetingTypeName = (appointment) => {
  let simplified = ''
  if (appointment && appointment.externalMeetingProvider) {
    simplified = appointment.externalMeetingProvider
      .replace('-appointment', '')
      .replace('slot', '')

    if (simplified === SIMPLY_BOOK_ME) {
      simplified = 'store'
    }
  }

  return simplified
}

const getMeetingTypeMeta = (appointment, customerFormInput) => {
  let meetingTypeName = ''
  let storeSubSystem = ''
  let serviceId = ''
  let bookingSystem = ''
  if (appointment?.appointment?.externalMeetingProvider) {
    meetingTypeName = appointment.appointment.externalMeetingProvider.replace(
      '-appointment',
      ''
    )
    storeSubSystem = appointment.appointment.simplyBookMeSubsystem
    serviceId = appointment.appointment.serviceId
    bookingSystem = appointment.appointment.bookingSystem
  } else if (customerFormInput?.service) {
    meetingTypeName = customerFormInput.service
    storeSubSystem = customerFormInput.subsystem
    serviceId = customerFormInput.serviceId
    bookingSystem = customerFormInput.bookingSystem
  }
  return { meetingTypeName, storeSubSystem, serviceId, bookingSystem }
}

const getService = ({
  appointment,
  services,
  bookingSystem,
  storeSubSystem,
}) => {
  const serviceName = getMeetingTypeName(appointment)
  const serviceContent = getMeetingTypeContent({
    meetingTypes: services,
    currentMeetingTypeName: serviceName,
    bookingSystem,
    storeSubSystem,
    serviceId: appointment.serviceId,
  })

  return serviceContent
}

export {
  findServiceData,
  getMeetingTypeContent,
  getMeetingTypeName,
  getMeetingTypeMeta,
  getService,
}
